import { IsIP } from "class-validator";

export default class IPv4 {
  @IsIP('4')
  public ip: string
}